import React, { CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import ChatCard from '../ChatCard/ChatCard';
import DirectMessages from './components/DirectMessages/DirectMessages';
import GroupMessages from './components/GroupMessages/GroupMessages';

import './ChatLists.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  tooltipElement?: React.ReactNode;
}

const ChatLists: React.FC<Props> = ({ style }) => {
  const { t } = useTranslation('common');

  return (
    <div className="chat-list-container" style={style}>
      <ChatCard>
        <ChatCard.Header title={t('Chat List')} membersButton={false} pinButton={false} />
        <ChatCard.Body>
          <div className="subject-rooms">
            <GroupMessages />
            <DirectMessages />
          </div>
        </ChatCard.Body>
      </ChatCard>
    </div>
  );
};

export default ChatLists;
